export const ENV = process.env.NODE_ENV;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
